module.exports = __webpack_public_path__ + "c8c039cd565f3c3d37c6d77cf74d70b0.pdf";